<script setup lang="ts">
interface PageTabContentProps {
  hideContentSheet?: boolean;
}

withDefaults(defineProps<PageTabContentProps>(), {
  hideContentSheet: false,
});
</script>

<template>
  <div class="base-page-tab-content">
    <v-sheet v-if="!hideContentSheet" class="flex-grow-1 mt-6 pa-6">
      <slot />
    </v-sheet>
    <div v-else class="flex-grow-1 py-6">
      <slot />
    </div>
  </div>
</template>
